import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const benefits = [
  {
    icon: 'ri-flashlight-line',
    title: 'Выплаты без задержек',
    desc: 'Деньги приходят сразу после оплаты клиентом. Никаких «раз в месяц» или «при накоплении N рублей».',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Персональный менеджер',
    desc: 'Закреплённый менеджер помогает с материалами, отвечает на вопросы и сопровождает ваших клиентов на всех этапах.',
  },
  {
    icon: 'ri-file-copy-line',
    title: 'Маркетинговые материалы',
    desc: 'Готовые баннеры, тексты для постов, лендинги и кейсы — всё, чтобы вам было легко рекомендовать AIGAM.',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Прозрачная аналитика',
    desc: 'Видите каждого приведённого клиента, его статус, сумму оплаты и начисленную комиссию в реальном времени.',
  },
  {
    icon: 'ri-infinity-line',
    title: 'Без ограничений по доходу',
    desc: 'Приводите сколько угодно клиентов — ваш доход ничем не ограничен. Нет потолка комиссий.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Работаем официально',
    desc: 'Заключаем партнёрский договор. Выплаты прозрачные и легальные, возможна работа с ИП и юрлицами.',
  },
];

export default function PartnerBenefits() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { containerRef: cardsRef, revealedCount: cardsRevealed } = useScrollRevealGroup<HTMLDivElement>(6);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Почему с нами выгодно
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Что вы получаете как партнёр AIGAM
          </h2>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {benefits.map((item, i) => (
            <div
              key={item.title}
              className={`rounded-2xl bg-background-100 border border-background-200/70 p-5 md:p-6 hover:border-primary-500/30 transition-all duration-300 group reveal-fade-up ${i < cardsRevealed ? 'revealed' : ''}`}
              style={i < cardsRevealed ? { transitionDelay: `${i * 80}ms` } : undefined}
            >
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 group-hover:scale-110 transition-all">
                <i className={`${item.icon} text-primary-600 text-lg`}></i>
              </div>
              <h3 className="font-display font-bold text-[16px] md:text-[17px] text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-[13px] md:text-[14px] text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}